module.exports = __webpack_public_path__ + "img/horizontal.5c90f177.svg";